// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2522":"1a19d9cc3a2d3c48","3837":"aa29c5816231a2a7","5972":"8e240aea6ef100ca"}[chunkId] + ".js";
};